module.exports = __webpack_public_path__ + "static/media/phone.5b6b2298.png";